module.exports = __webpack_public_path__ + "img/arrow-circle-right-outline-orange.de6e86a4.svg";